
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const onSelect = createOnFilter(onFilter)

  const hasList = (list) => list && list.length > 0
  const { costCentres, serviceDueDates, agreementTypes, estServiceDueDateStatuses, serviceBookedFlags, fmoTypes, controllers } = filters

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasList(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={[{ label: 'No cost centre', value: '-' }, ...costCentres]}
            value={filtered.costCentre}
            onChange={onSelect('costCentre')}
            includeEmptyOption
            emptyOptionLabel="All cost centres" />
        )}
        {hasList(serviceDueDates) && (
          <MuiFormSelect
            id="serviceDueDate"
            label="Estimated next service due"
            options={serviceDueDates}
            value={filtered.serviceDueDate}
            onChange={onSelect('serviceDueDate')}
            includeEmptyOption />
        )}
        {hasList(agreementTypes) && (
          <MuiFormSelect
            id="agreementType"
            label="Agreement Type"
            options={agreementTypes}
            value={filtered.agreementType}
            onChange={onSelect('agreementType')}
            includeEmptyOption />
        )}
        {hasList(estServiceDueDateStatuses) && (
          <MuiFormSelect
            id="estServiceDueDateStatus"
            label="Service Due Date Status"
            options={estServiceDueDateStatuses}
            value={filtered.estServiceDueDateStatus}
            onChange={onSelect('estServiceDueDateStatus')}
            includeEmptyOption />
        )}
        {hasList(serviceBookedFlags) && (
          <MuiFormSelect
            id="serviceBooked"
            label="Service Booked"
            options={serviceBookedFlags}
            value={filtered.serviceBooked}
            onChange={onSelect('serviceBooked')}
            includeEmptyOption />
        )}
        {hasList(fmoTypes) && (
          <MuiFormSelect
            id="fmoType"
            label="FMO"
            options={fmoTypes}
            value={filtered.fmoType}
            onChange={onSelect('fmoType')}
            includeEmptyOption />
        )}
        {hasList(controllers) && (
          <MuiFormSelect
            id="controller"
            label="Controller"
            options={controllers}
            value={filtered.controller}
            onChange={onSelect('controller')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
